// @ts-nocheck
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Clipboard from 'v-clipboard';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { Icon as IconifyIcon } from '@iconify/vue';
import constants from '@/constants';
import * as Sentry from '@sentry/vue';

import ElementUI from 'element-plus';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import VueAwesomePaginate from 'vue-awesome-paginate';
import VueScrollShadow from 'vue3-scroll-shadow';
import VuePaginate from 'vue-paginate';
import Paginate from 'vuejs-paginate';
import Vue3Toasity from 'vue3-toastify';
import InfiniteLoading from 'v3-infinite-loading';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { install } from 'vue3-recaptcha-v2';

import 'vue3-easy-data-table/dist/style.css';
import 'vue-awesome-paginate/dist/style.css';
import 'element-plus/dist/index.css';
import 'vue3-toastify/dist/index.css';
import 'v3-infinite-loading/lib/style.css'; //required if you're not going to override default slots
import 'vue3-carousel/dist/carousel.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import App from './App.vue';
import router from './router/router';
import plugins from './plugins';
import { loadElements } from './components/elements';
import { loadPrototypes } from './prototypes';

const pinia = createPinia();
const app = createApp(App);

const sentryEnv = process.env.NODE_ENV === 'development' ? 'development' : 'production';

Sentry.init({
  app,
  dsn: 'https://3d5802e4e9898c722d427263878b4d5c@o4508890687995904.ingest.de.sentry.io/4508890795933776',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  environment: sentryEnv,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(VueReCaptcha, {
  siteKey: constants.recaptchaSiteKeyV3, // Replace with your actual reCAPTCHA site key
  loaderOptions: {
    useRecaptchaNet: true, // Use Google's reCAPTCHA CDN
    useEnterprise: true, // Use reCAPTCHA Enterprise
  },
});

app.use(install, {
  sitekey: constants.recaptchaSiteKeyV2,
  cnDomains: false, // Optional, If you use in China, set this value true
});

app.use(pinia);
app.use(router);
app.use(Clipboard);
app.use(ElementUI);
app.use(VuePaginate);
app.use(VueAwesomePaginate);
// app.use(plugins.posthog);
app.use(Vue3Toasity);

app.component('paginatejs', Paginate);
app.component('fa-icon', FontAwesomeIcon);
library.add(fas, far); // Font Awesome library
app.component('iconify-icon', IconifyIcon);
app.component('scroll-shadow', VueScrollShadow);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('infinite-loading', InfiniteLoading);
app.component('VueDatePicker', VueDatePicker);

loadElements(app);
loadPrototypes(app);

app.mount('#app');
